import React, { useEffect } from "react";
import NCallSchedular from "../../components/calendar/schedular";
import { useNavigate } from "react-router-dom";
import { useNCallContext } from "../../context/ncall-context";
import NoData from "../../components/noData";
import { showInfoToast } from "../../utils/toast";

const ClientCalendar = () => {
  const { getDepartments, state } = useNCallContext();

  const navigate = useNavigate();
  useEffect(() => {
    if (localStorage.getItem("logged-in-as") == "admin") {
      navigate("/admin");
    }

    // Adding this code to clear the local storage if the scheduler variable is set to default values.
    const schedulerState = localStorage.getItem("scheduler");
    if (
      schedulerState === null ||
      schedulerState === "f4b7a1e0-5a2f-4a39-a548-1c7b993e1c13" ||
      schedulerState === "c69ad4b4-99d9-43ea-bb4b-f3cc762a9d12"
    ) {
      console.log(
        "Clearing the scheduler variable state and restarting the application. Value: ",
        schedulerState
      );
      showInfoToast("App is being updated. Please enter the code again.");

      setTimeout(() => {
        localStorage.clear();
        window.location.reload();
      }, 3000);
    }
  }, []);

  useEffect(() => {
    if (state.departments.length === 0) {
      getDepartments();
    }
  }, []);

  return state.departments.length > 0 ? (
    <NCallSchedular />
  ) : (
    <NoData
      message={`Scheduler is not configured for the ${localStorage.getItem(
        "companyName"
      )}`}
    />
  );
};

export default ClientCalendar;
